export const cCategoriaArticulo = {
    general: 5100,
    vehiculos: 5101,
    telefono: 5100,
    vehiculosConsignacion: 122,
};

export const lstCategoriaArticulo = [
    {
        id: cCategoriaArticulo.general,
        nombre: "General",
        icon: 'boxes',
        visible:true,
    },
    {
        id: cCategoriaArticulo.vehiculos,
        nombre: "Vehiculos",
        icon: 'vehicle',
        visible:false
    }
];

export const lstCategoriaArticuloRecogidoLiquidado = [
    {
        id: cCategoriaArticulo.general,
        nombre: "General",
        icon: 'boxes',
        visible:true,
    },
];

export const lstCategoriaArticuloTicketCobol = [
    {
        id: cCategoriaArticulo.general,
        nombre: "General",
        icon: 'boxes',
        visible:true,
    },
    {
        id: cCategoriaArticulo.vehiculos,
        nombre: "Vehiculos",
        icon: 'vehicle',
        visible:false
    },
    {
        id: cCategoriaArticulo.vehiculosConsignacion,
        nombre: "Vehiculo consignación",
        icon: 'vehicle',
        visible:false
    }
];